import { render, staticRenderFns } from "./arrow-right.vue?vue&type=template&id=0f11fd0a&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f11fd0a",
  null
  
)

export default component.exports